import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-500 mt-4 -mb-16"
}
const _hoisted_3 = { class: "mt-20" }

import { // auth
		Auth
	} from '@/api/Auth'

	import { // components
		Dialog, 
		DialogTitle, 
		DialogDescription, 
		DialogOverlay,
		TransitionRoot, 
		TransitionChild
	} from '@headlessui/vue'
	import {
		XMarkIcon
	} from '@heroicons/vue/24/outline'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // router
		useRouter
	} from 'vue-router'
	
	import { // stores
		store as _userStore
	} from '@/store/user'

	import { // types
		Notification
	} from '@/types'

	import { // vue
		ref
	} from 'vue'

	
	
	const __default__ = { name: "ChangePasswordForm" } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['closePasswordModal'],
  setup(__props, { emit: __emit }) {

	const userStore = _userStore()
	const router = useRouter()
	
	const {t} = useI18n()

	let email = userStore.user.email
	
	const currentPassword = ref("")
	const newPassword = ref("")
	const confirmNewPassword = ref("")
	const error = ref(false)
	const errorMsg = ref('')
	const formLoading = ref(false)
	const inputPassword = ref<null | {valid: Boolean}>(null)
	const inputNewPassword = ref<null | {valid: Boolean}>(null)
	const inputConfirmNewPassword = ref<null | {valid: Boolean}>(null)
	const passwordConfirmMessage = ref(t('updatePassword.confirmPasswordError'))
	const passwordValidateMessage = ref(t('updatePassword.confirmPasswordError'))

	const emit = __emit

	async function updatePassword() {
		formLoading.value = true
		let formError = false
		
		if (currentPassword.value == "") {
			document.getElementById('currentPassword')?.focus()
			if(inputPassword.value)inputPassword.value.valid = false
			formError = true
		}
		if (newPassword.value == "") {
			document.getElementById('newEmail')?.focus()
			passwordValidateMessage.value = t('updatePassword.newPasswordValidation')
			if(inputNewPassword.value)inputNewPassword.value.valid = false
			formError = true
		}
		if (newPassword.value == currentPassword.value && newPassword.value != null && newPassword.value != "") {
			document.getElementById('newEmail')?.focus()
			passwordValidateMessage.value = t('updatePassword.differentPasswordError')
			if(inputNewPassword.value)inputNewPassword.value.valid = false
			formError = true
		}
		if (confirmNewPassword.value == "") {
			document.getElementById('email')?.focus()
			if(inputConfirmNewPassword.value)inputConfirmNewPassword.value.valid = false
			formError = true
		}
		if (newPassword.value != confirmNewPassword.value) {
			document.getElementById('confirmNewEmail')?.focus()
			passwordConfirmMessage.value = t('updatePassword.passwordMismatch')
			if(inputConfirmNewPassword.value)inputConfirmNewPassword.value.valid = false
			formError = true
		}	
		
		if(formError) {
			formLoading.value = false
			return
		}

		try {
			error.value = false
			errorMsg.value = ''

			let response = await Auth.changePassword(email, currentPassword.value, newPassword.value)

			if(!response.success) {
				error.value = true
				errorMsg.value = response?.messages?.[0]?.message ?? t('updatePassword.error')
				throw errorMsg.value
			}
			
			const notification: Notification = {
				title: t('placeholders.success'),
				subtitle: t('updatePassword.passwordUpdated'),
				icon: 0
			}

			emit('closePasswordModal', notification)
			currentPassword.value = ""
			newPassword.value = ""
			confirmNewPassword.value = ""
			router.push({name: 'Account'})
		} 
		catch(e) {
			console.log(e)
		}
		finally {
			formLoading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DialogDescription), {
      as: "h3",
      class: "mb-6"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('changePassword.description')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("form", {
      onSubmit: _withModifiers(updatePassword, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_tw_input, {
          modelValue: currentPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
          id: "currentPassword",
          ref_key: "inputPassword",
          ref: inputPassword,
          required: true,
          type: "password",
          label: _unref(t)('updatePassword.currentPassword'),
          validation: _unref(t)('updatePassword.currentPasswordValidation'),
          class: "text-md"
        }, null, 8, ["modelValue", "label", "validation"]),
        _createVNode(_component_tw_input, {
          modelValue: newPassword.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
          id: "newPassword",
          ref_key: "inputNewPassword",
          ref: inputNewPassword,
          required: true,
          type: "password",
          label: _unref(t)('updatePassword.newPassword'),
          validation: passwordValidateMessage.value,
          class: "text-md"
        }, null, 8, ["modelValue", "label", "validation"]),
        _createVNode(_component_tw_input, {
          modelValue: confirmNewPassword.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmNewPassword).value = $event)),
          id: "confirmNewPasword",
          ref_key: "inputConfirmNewPassword",
          ref: inputConfirmNewPassword,
          required: true,
          type: "password",
          label: _unref(t)('updatePassword.confirmNewPassword'),
          validation: passwordConfirmMessage.value
        }, null, 8, ["modelValue", "label", "validation"])
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMsg.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_tw_button, {
          disabled: formLoading.value,
          loading: formLoading.value,
          type: "submit",
          class: "btn-base btn-brand w-full",
          onClick: updatePassword
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('changePassword.title')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ], 64))
}
}

})